import { ChannelType } from 'components/CampaignCreationModal/Types'
import { DesignChannel } from 'components/NewFileModal/Types'
import { useFlipperFlag } from 'hooks/useFlipperFlag'

const postableChannels = [
  ChannelType.LinkedInPosts,
  ChannelType.InstagramPosts,
  ChannelType.Tweets,
  ChannelType.FacebookPost,
  ChannelType.BlogPost,
  ChannelType.Newsletter,
  DesignChannel.InstagramPost,
  DesignChannel.InstagramReel,
  DesignChannel.InstagramStory,
  DesignChannel.FacebookPost,
  DesignChannel.LinkedInPost,
  DesignChannel.TwitterPost,
  DesignChannel.TikTokPost,
  DesignChannel.YoutubeShort,
]

const socialPostableChannels = [
  ChannelType.LinkedInPosts,
  ChannelType.InstagramPosts,
  ChannelType.Tweets,
  ChannelType.FacebookPost,
  DesignChannel.LinkedInPost,
  DesignChannel.InstagramPost,
  DesignChannel.InstagramReel,
  DesignChannel.TwitterPost,
  DesignChannel.FacebookPost,
  DesignChannel.InstagramStory,
  DesignChannel.TikTokPost,
  DesignChannel.YoutubeShort,
]

const isChannelPostable = (
  channel: ChannelType | DesignChannel | undefined,
  enabledChannels: Array<ChannelType | DesignChannel>,
) => {
  if (!channel) {
    return false
  }

  return enabledChannels.includes(channel)
}

export const useIsChannelPostable = () => {
  const tikTokEnabled = useFlipperFlag('tiktok_integration')
  const youtubeEnabled = useFlipperFlag('youtube_integration')
  let filteredPostableChannels = postableChannels
  let filteredSocialPostableChannels = socialPostableChannels

  if (!tikTokEnabled) {
    filteredPostableChannels = filteredPostableChannels.filter((channel) => channel !== DesignChannel.TikTokPost)
    filteredSocialPostableChannels = filteredSocialPostableChannels.filter(
      (channel) => channel !== DesignChannel.TikTokPost,
    )
  }

  if (!youtubeEnabled) {
    filteredPostableChannels = filteredPostableChannels.filter((channel) => channel !== DesignChannel.YoutubeShort)
    filteredSocialPostableChannels = filteredSocialPostableChannels.filter(
      (channel) => channel !== DesignChannel.YoutubeShort,
    )
  }

  return {
    isChannelPostable: (channel: ChannelType | DesignChannel | undefined) =>
      isChannelPostable(channel, filteredPostableChannels),
    isChannelSocialPostable: (channel: ChannelType | DesignChannel | undefined) =>
      isChannelPostable(channel, filteredSocialPostableChannels),
  }
}
